<template>
  <div
    class="cmp-contact-contacts-payment_terms dbox"
    v-if="accountingInfo.contact"
  >
    <TextField2
      :id="`${pt_prefix}_due_days`"
      :value="accountingInfo.contact[`${pt_prefix}_due_days`]"
      :label="$t('due_days')"
      :placeholder="$t('due_days')"
      @change="onTextFieldValueChange"
    />
    <Checkbox2
      :id="`${pt_prefix}_end_of_month_flag`"
      :label="$t('end_of_month')"
      :value="
        accountingInfo.contact[`${pt_prefix}_end_of_month_flag`]
      "
      :placeholder="$t('end_of_month')"
      @input="onCheckboxChange"
    />
    <TextField2
      :id="`${pt_prefix}_discount_days`"
      :value="
        accountingInfo.contact[`${pt_prefix}_discount_days`]
      "
      :label="$t('discount_days')"
      :placeholder="$t('discount_days')"
      @change="onTextFieldValueChange"
    />
    <TextField2
      :id="`${pt_prefix}_discount_percent`"
      :ta="'left'"
      :type="'number'"
      :value="
        accountingInfo.contact[`${pt_prefix}_discount_percent`]
      "
      :label="$t('discount_percent')"
      :placeholder="$t('discount_percent')"
      @change="onTextFieldValueChange"
    />
    <Dropdown2
      :label="$t('payment_methods')"
      :options="paymentMethodsTV"
      :selected="
        paymentMethodsTV.find(
          (c) =>
            c.value ==
            accountingInfo.contact[
              `${pt_prefix}_payment_method_id`
            ]
        )
      "
      :placeholder="$t('payment_method')"
      :bb="'0px'"
      v-on:selectedChange="
        (e) =>
          onDropdownChange(`${pt_prefix}_payment_method_id`, e)
      "
    />
  </div>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";

import { EventHooks } from "../../../../plugins/text-field";
import { createCountriesTV } from "../../../../models/country.model";
import { createCurrencyTV } from "../../../../models/currency.model";
import { sentenceToLowerSnakeCase } from '../../../../utility';

export default {
  components: {
    TextField,
    Dropdown,
  },
  props: {
    accountingInfo: {
      type: Object,
      required: true,
    },
    pt_prefix: {
      type: String,
      default: () => "invoice",
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    };
  },
  computed: {
    paymentMethodsTV: function () {
      return (this.accountingInfo.payment_methods || []).map(
        (e) => ({
          text: this.$t(sentenceToLowerSnakeCase(e.payment_method_name)),
          value: e.payment_method_id,
        })
      );
    },
  },
  methods: {
    onTextFieldValueChange: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      console.log({ name, value: value.value });
      this.$emit("changed", { name, value: value.value });
    },
    onEndOfMonthClick: function (name, event) {
      const value = event.target.checked === true ? "1" : "0";
      this.$emit("changed", { name, value });
    },
    onCheckboxChange: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value: value === true ? "1" : "0",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group .dt-dropdown {
  margin: 5px 5px !important;
}

.eom-flag {
  display: flex;
  .dt-checkbox,
  .eom-label {
    margin-left: 7px;
    margin-top: 15px;
  }
}
</style>
